import { FlowChartNode } from './flow-chart-node';

export class FlowChartNodeWithCoordinates extends FlowChartNode {
  vx: number;
  vy: number;
  x: number;
  y: number;
}
